import React, { Component } from 'react'
import cx from 'classnames'
import { Layout, Container, NavBottom } from 'src/components/Layout'
import { injectIntl } from 'react-intl'
import { isNavBottomVisible } from 'src/utils/features'
import List from 'src/components/List'
import NotificationBanner from 'src/components/NotificationBanner'
import { getCurrentPageUrlInfo, getKioskDocument } from 'src/utils/helpers'
import { isColorWhite } from 'src/utils/colors'

// TODO: Convert to modular CSS
import './Sidebar.less'
import styles from './Sidebar.module.less'

class Sidebar extends Component {
  render() {
    const {
      isSidebarVisible,
      location,
      isChatOnlyFeature,
      features,
      chatOptions,
      isAfterHours,
      isChatEmpty,
      areAppActionsDisabled,
      bannerNotification,
      notificationHeight,
      isNotificationHidden,
      featuresAndOptions,
      pageBackground,
    } = this.props
    // Append right icon to each feature
    const mainMenuItems = featuresAndOptions.map(feature => {
      return {
        ...feature,
        id: feature.id,
        name: feature.title,
        leftIconType: feature.icon.type,
        rightIcon: 'right',
      }
    })

    const currentPageUrl = getCurrentPageUrlInfo(location, 'url')

    const isChatPage = currentPageUrl === '/chat'
    const isProfilePage = currentPageUrl.includes('user') || currentPageUrl.includes('auth')

    const classNames = cx({
      [styles.hideOnMobile]: isSidebarVisible === false || isChatPage || isProfilePage,
      'c-layout-sidebar': true,
      'c-layout-sidebar--bordered': isColorWhite(pageBackground),
    })

    const withBottomNavCls = isNavBottomVisible(
      features,
      chatOptions,
      isAfterHours,
      isChatEmpty,
      isChatOnlyFeature,
    )
      ? ' with-bottom-nav'
      : ''

    const containerStyleWithNotification =
      isNotificationHidden || getKioskDocument().body.clientWidth > 990
        ? {}
        : {
            height: `calc(100% - 100px - 20px * 2 - ${notificationHeight}px)`,
            marginTop: `calc(100px + 20px * 2 + ${notificationHeight}px)`,
          }

    return (
      <>
        <Layout className={classNames}>
          <NotificationBanner
            className={styles.displayingNotification}
            bannerNotification={bannerNotification}
          />
          <Container
            className={'sidebar-container' + withBottomNavCls}
            style={containerStyleWithNotification}
          >
            <List
              className='kiosk--chakra-colors-background'
              items={mainMenuItems}
              isMainMenu={true}
              preventActiveState={isChatPage}
              areAppActionsDisabled={areAppActionsDisabled}
              attrDataQa='list-main-menu'
            />
            <div className={styles.fillOutSpace + ' kiosk--chakra-colors-background'} />
          </Container>
        </Layout>
        <NavBottom className={styles.sidebarNavBottom} />
      </>
    )
  }
}

export default injectIntl(Sidebar)
